import { updateIndicator } from "@/components/shortlist.js";
import { defineStore } from "pinia";

function emptyShortlist() {
    localStorage.setItem("waiheke-shortlist", JSON.stringify([]));
    updateIndicator();
}

function getStorage() {
    const value = localStorage.getItem("waiheke-shortlist");

    if (!value) {
        emptyShortlist()
    }

    const storage = JSON.parse(value);

    if (storage === null) {
        emptyShortlist();
    }

    if (!Array.isArray(storage)) {
        emptyShortlist();
    }

    return storage;
}

export const useShortlistStore = defineStore("shortlist", {
    state: () => {
        return {
            value: getStorage(),
            data: null,
        };
    },
    actions: {
        async getData() {
            if (this.value.length === 0) {
                return;
            }

            let { origin, pathname } = window.location;

            if (pathname.slice(-1) !== "/") {
                pathname = `${pathname}/`;
            }

            const URLParam = encodeURIComponent(JSON.stringify(this.value));
            const path = origin + pathname + "getShortlist" + "?s=" + URLParam;

            // @TODO this has no error handling
            fetch(path, {
                method: "get",
                headers: {
                    "Content-Type": "application/json",
                    "x-requested-with": "XMLHttpRequest",
                },
            })
                .then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                })
                .then((data) => {
                    this.data = data;
                });
        },
        add(id, data = null) {
            if (typeof id !== "number") {
                throw "Id must be a number.";
            }

            if (this.value.indexOf(id) > -1) {
                return;
            }

            this.value.push(id);

            if (data) {
                this.data.push(data);
            }

            localStorage.setItem(
                "waiheke-shortlist",
                JSON.stringify(this.value)
            );

            updateIndicator();
        },
        remove(id) {
            if (typeof id !== "number") {
                throw "Id must be a number.";
            }

            const index = this.value.indexOf(id);

            if (this.value.indexOf(id) < 0) {
                return;
            }

            this.value.splice(index, 1);

            this.data = this.data.filter((item) => {
                return item.id != id;
            });

            localStorage.setItem(
                "waiheke-shortlist",
                JSON.stringify(this.value)
            );

            updateIndicator();
        },
        mergeData(list) {
            if (!Array.isArray(list)) {
                throw "Only arrays can be merged.";
            }

            if (this.data === null) {
                this.data = list;
            }

            list.forEach((listing) => {
                const exists = this.data.find((item) => {
                    return item.id === listing.id;
                });

                if (!exists) {
                    this.data.push(listing);
                }
            });

            this.value = this.data.map((listing) => listing.id);

            localStorage.setItem(
                "waiheke-shortlist",
                JSON.stringify(this.value)
            );

            updateIndicator();
        },
        replace(list) {
            if (!Array.isArray(list)) {
                throw "Only arrays can be replaced.";
            }

            list.forEach((id) => {
                if (typeof id !== "number") {
                    throw "Only replacable with an array of ids.";
                }
            });

            this.value = list;

            localStorage.setItem(
                "waiheke-shortlist",
                JSON.stringify(this.value)
            );

            updateIndicator();
        },
        replaceData(list) {
            if (!Array.isArray(list)) {
                throw "Only arrays can be replaced.";
            }

            list.forEach((item) => {
                if (!item.id) {
                    throw "All items must have an id.";
                }
            });

            this.value = list.map((item) => item.id);

            localStorage.setItem(
                "waiheke-shortlist",
                JSON.stringify(this.value)
            );

            updateIndicator();
        },
    },
});
